module.exports.seq = require("./seq");



//////////////////
// WEBPACK FOOTER
// ./~/biojs-model/src/index.js
// module id = 95
// module chunks = 0